import { gql } from '@apollo/client';
const ADD_ORDER = gql `
  mutation AddOrder {
    addOrder {
      order {
        id
        season {
          id
          name
          workingSeason
        }
      }
    }
  }
`;
export default ADD_ORDER;
